import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private readonly loadingCount = new BehaviorSubject<number>(0);

  readonly loading$: Observable<boolean> = this.loadingCount.pipe(
    map((count) => count > 0)
  );

  show(): void {
    this.loadingCount.next(this.loadingCount.value + 1);
  }

  hide(): void {
    const current = this.loadingCount.value;
    if (current > 0) {
      this.loadingCount.next(current - 1);
    }
  }
}

